<template>
  <div id="bl-main">
    <BackTop></BackTop>
    <div class="header">
      <router-view name="bl-header"></router-view>
    </div>
    <div class="content">
      <router-view name="bl-content"></router-view>
    </div>
    <div class="footer">
      <router-view name="bl-footer"></router-view>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'master',
    created(){
      window.$vue = this;
    },
  }
</script>

<style lang="less">
  @import "theme/default";
  
  html, body {
    margin: 0;
    padding: 0;
    height: 100%;
  }
  
  #bl-main {
    min-height: 100%;
    
    .header {
      height: @header_height;
    }
    
    .content {
    }
    
    .footer {
      // set by BFooter
    }
  }
  
  .icon {
    fill: currentColor;
    overflow: hidden;
  }
  
  *::-webkit-scrollbar {
    width: 3px;
    height: 3px;
    background-color: rgba(255, 255, 255, 0);
  }
  
  *::-webkit-scrollbar-track {
    /*border-radius: 10px;*/
    background-color: #f5f5f5;
  }
  
  *::-webkit-scrollbar-thumb {
    /*height: 3px;*/
    /*border-radius: 10px;*/
    background-color: #3071a9;
  }
</style>
